import { gql } from "@apollo/client";

const UPDATE_BILLING_ADDRESS = gql`
  mutation UpdateBillingAddress($input: UpdateBillingAddressInput!) {
    updateBillingAddress(input: $input) {
      me {
        billingAddressLine1
        billingAddressLine2
        billingCity
        billingState
        billingCountry
        billingZipCode
      }
    }
  }
`;

export default UPDATE_BILLING_ADDRESS;
